<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-service-orders-table'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-service-orders-table"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative font-small-3"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="fields"
          primary-key="id"
          :empty-text="$t('NO MATCHING RECORDS FOUND')"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(service)="data">
            <h5>
              <b-badge variant="light-success">
                {{ data.item.service }}
              </b-badge>
            </h5>
          </template>
          <template #cell(travel)="data">
            <div
              class="d-flex justify-content-center align-items-center"
              v-if="data.item.travel_order_id != null"
            >
              <h5>
                <b-badge variant="light-info">
                  {{ data.item.travel }}
                </b-badge>
              </h5>
              <tabler-icon
                icon="EyeIcon"
                class="text-primary cursor-pointer"
                size="17"
                style="margin-left: 7px"
                v-b-tooltip.hover.v-primary
                :title="$t('View travel')"
              />
            </div>
            <div v-else class="d-flex justify-content-center">
              <h5>
                <b-badge variant="light-danger">
                  {{ $t("Not assigned") }}
                </b-badge>
              </h5>
              <tabler-icon
                icon="PlusIcon"
                size="17"
                class="text-success"
                style="margin-left: 7px"
                v-b-tooltip.hover.v-primary
                :title="$t('Assign travel')"
              />
            </div>
          </template>

          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status != null"
              :variant="getTravelOrderVariant(data.item.status)"
            >
              {{ $t(data.item.status) }}
            </b-badge>
            <b-badge v-else variant="light-danger">
              {{ $t("Not assigned") }}
            </b-badge>
          </template>
          <template #cell(business_name)="data">
            <div class="d-flex">
              <span> {{ data.item.business_name }} </span>
            </div>
          </template>
          <template #cell(service_type)="data">
            <div class="d-flex justify-content-center">
              <span> {{ data.item.service_type }} </span>
            </div>
          </template>
          <template #cell(qty_documents)="data">
            <h5>
              <b-badge
                :variant="data.value > 0 ? 'light-info' : 'light-danger'"
              >
                {{ data.item.qty_documents }}
              </b-badge>
            </h5>
          </template>
          <template #cell(quantity)="data">
            <span
              :class="{
                'text-primary': data.value > 0,
                'text-danger': data.value == 0,
              }"
            >
              {{ data.value }}
            </span>
          </template>
          <template #cell(volume)="data">
            <span
              :class="{
                'text-primary': data.value > 0,
                'text-danger': data.value == 0,
              }"
            >
              {{ data.item.volume.toFixed(2) }}
            </span>
          </template>
          <template #cell(weight)="data">
            <span
              :class="{
                'text-primary': data.value > 0,
                'text-danger': data.value == 0,
              }"
            >
              {{ data.item.weight.toFixed(2) }}
            </span>
          </template>
          <template #cell(created_at)="data">
            <div class="d-flex flex-column">
              <span>
                <feather-icon icon="UserIcon" class="text-primary mr-1" />
                <span class="text-primary">{{ data.item.created_by }}</span>
              </span>
              <span>
                <feather-icon icon="CalendarIcon" class="text-muted mr-1" />
                <span class="text-muted">{{
                  data.item.created_at | prettyDate
                }}</span>
              </span>
            </div>
            <!-- <div
              class="d-flex align-items-left justify-content-left flex-column"
            >
              <div class="mt-05">
                <feather-icon
                  icon="UserIcon"
                  size="17"
                  class="text-primary mr-1"
                />
                <span class="text-primary">{{ data.item.created_by }}</span>
              </div>
              <div class="mt-05"></div>
            </div> -->
          </template>

          <template #cell(actions)="data">
            <!-- <feather-icon
              @click="changeStatus(data.item)"
              :icon="typeTab == 1 ? 'ThumbsDownIcon' : 'ThumbsUpIcon'"
              size="17"
              class="cursor-pointer"
              :class="typeTab == 1 ? 'text-danger' : 'text-success'"
              v-b-tooltip.hover.left="
                $t(typeTab == 1 ? 'DEACTIVATE' : 'ACTIVATE')
              "
            /> -->
            <feather-icon
              @click="editService(data.item)"
              icon="EditIcon"
              size="17"
              class="cursor-pointer text-warning ml-1"
              v-b-tooltip.hover.v-warning
              :title="$t('Edit service')"
            />
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AddServiceOrderModal
      v-if="showServiceOrderModal"
      :serviceId="serviceId"
      @close="showServiceOrderModal = false"
      @save="(showServiceOrderModal = false), refreshTable()"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import fields from "@/views/operations/views/service-orders/data/fields.data.js";
import filters from "@/views/operations/views/service-orders/data/filters.data.js";
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";
import ServiceOrdersService from "@/views/operations/views/service-orders/services/service-orders.service.js";
import TravelOrdersService from "@/views/operations/views/travel-orders/services/travel-orders.service.js";
import AddServiceOrderModal from "@/views/operations/views/service-orders/components/AddServiceOrderModal.vue";

export default {
  components: {
    FilterSlot,
    AddServiceOrderModal,
  },
  data() {
    return {
      filters: [],
      filters,
      fields,
      isBusy: false,
      searchQuery: "",
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "SEARCH...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      dataMeta: {
        from: 0,
        to: 0,
        of: 0,
      },
      showServiceOrderModal: false,
      serviceId: null,
    };
  },
  computed: {
    typeTab() {
      return this.$route.meta.tab;
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {},
  mounted() {
    this.getTravelOrderStatusEnum();
  },
  methods: {
    async getTravelOrderStatusEnum() {
      try {
        const { data } = await TravelOrdersService.getTravelOrderStatusEnum();
        data.forEach((item) => {
          item.name = this.$t(item.name);
        });
        this.filters[2].options = data;
      } catch (error) {
        console.log(error);
      }
    },
    async myProvider(ctx) {
      try {
        let sortBy;

        switch (ctx.sortBy) {
          case "service_order":
            sortBy = 3;
            break;
          case "driver":
            sortBy = 1;
            break;
          case "travel_order_status":
            sortBy = 9;
            break;
          case "documents_orders":
            sortBy = 10;
            break;
          case "created_at":
            sortBy = 4;
            break;
          default:
            sortBy = 1;
            break;
        }
        this.addPreloader();
        let params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          orderby: sortBy,
          order: ctx.sortDesc ? "ASC" : "DESC",
          from: this.filters[0].model,
          to: this.filters[1].model,
          status: this.filters[2].model,
        };
        const { data } = await ServiceOrdersService.getServiceOrders(params);
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data || [];
      } catch (error) {
        console.log(error);
        return [];
      } finally {
        this.removePreloader();
      }
    },

    editService(item) {
      this.serviceId = item.id;
      this.showServiceOrderModal = true;
    },

    getTravelOrderVariant(status) {
      let style = "light-default";
      switch (status) {
        case "Registered":
          style = "light-default";
          break;
        case "Initiated":
          style = "light-success";
          break;
        case "Returning":
          style = "light-warning";
          break;
        case "Returned":
          style = "light-info";
          break;
        case "Finished":
          style = "light-primary";
          break;
        default:
          break;
      }
      return style;
    },

    refreshTable() {
      this.$refs["ref-service-orders-table"].refresh();
    },
  },
};
</script>
<style lang="scss" scoped>
.mt-05 {
  margin-top: 0.5rem;
}
</style>
```
